const SET_SELECTED = 'SET_SELECTED';
interface SelectedType {
    type: typeof SET_SELECTED;
    key: typeof Number | any;
}

const selectedReducer = (state = -1, action: SelectedType) => {
    switch (action.type) {
        case SET_SELECTED:
            state = action.key;
            return state;
        default:
            return state;
    }
};

export default selectedReducer;
